import PropTypes from "prop-types";
import {capitaliseFirst, you} from "./__strings";

export default function employment(props) {
    const betterProps = {...props, ...{you: you(props.applicant === 1 ? false : props.mortgage.applicant2?.firstName ? props.mortgage.applicant2.firstName:'the other applicant')}}
    return {
        name: `employment-${props.applicant}`,
        title: 'Employment details',
        personalisedTitle: capitaliseFirst(betterProps.you.your) + ' employment details',
        link: `apply-${props.applicant}/employment`,
        props: props,
        questions: [
            employmentType(betterProps),
            currentEmployerName(betterProps),
            //TODO : Ask Question if employed Are you Full Time Employed / Full Time Temp / Part Time Employed / Part Time Temp / Contract Basis
            employmentBasis(betterProps),
            positionHeld(betterProps),
            currentEmployerAddress(betterProps),
           // currentEmployerContact(betterProps),
            currentEmployerPhone(betterProps),
            currentEmployerStartDate(betterProps),
            //currentEmployerYearsThere(betterProps),
            /* Not asked in Credit Logic */
            // previousEmployerName(betterProps),
            // previousEmployerAddress(betterProps),
            // previousEmployerYearsThere(betterProps),
            nameOfBusiness(betterProps),
            natureOfBusiness(betterProps),
            // TODO: Add Question for seld-employed, Is the business a limited company?
            limitedCompany(betterProps),
            // TODO: Add Question for self-employed, Are you a director or shareholder in the company?
            isDirector(betterProps),
            // TODO: Add Question for self-employed, What percentage of shares do you hold in the company?
            percentageOfShares(betterProps),
            businessAddress(betterProps),
            businessEstablished(betterProps),
            accountantName(betterProps),
            accountantAddress(betterProps),
            accountantPhone(betterProps)
        ]
    }
}
employment.propTypes = {
    applicant: PropTypes.number
};

export function employmentType(props) {
    return {
        label: "Employment Status",
        text: "What is " + props.you.your + " current employment status?",
        name: "employmentType",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Employed",
                    value: "EMPLOYED"
                },
                {
                    text: "Self-Employed",
                    value: "SELFEMPLOYED"
                },
                {
                    text: "Homemaker",
                    value: "HOMEMAKER"
                },
                {
                    text: "Student",
                    value: "STUDENT"
                }
            ]
        },
        model: "employment"
    }
}

export function employmentBasis(props) {
    return {
        text: "On what basis " + props.you.areYou + " employed?",
        label: "Employment Basis",
        name: "employmentBasis",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Full-time",
                    value: "FULLTIME"
                },
                {
                    text: "Temporary Full-time",
                    value: "TEMPFULLTIME"
                },
                {
                    text: "Part-time",
                    value: "PARTTIME"
                },
                {
                    text: "Temporary Part-time",
                    value: "TEMPPARTTIME"
                },
                {
                    text: "Contract Basis",
                    value: "CONTRACT"

                }
            ]
        },
        hides:{
            employmentType: (v) => {
                return v !== "EMPLOYED"
            }
        },
        model: "employment"
    }
}
export function positionHeld(props) {
    return {
        name: "positionHeld",
        label: "Position",
        text: "What is " + props.you.your + " position there?",
        answer: {
            type: "text"
        },
        hides: {
            employmentType: (v) => {
                return v !== "EMPLOYED"
            },
        },
        model: "employment"
    }
}
export function currentEmployerYearsThere(props) {
    return {
        label: "Years with Employer",
        text: "How many years " + props.you.areYou + " in employment there",
        name: "currentEmployerYearsThere",
        answer: {
            type: "int",
            validation: {
                min: {value: 1, message: "This must be a value greater than 1"},
                max: {value: 50, message: "50 is the maximum here"}
            }
        },
        hides: {
            employmentType: (v) => {
                return v !== "EMPLOYED"
            },
        },
        model: "employment"
    }
}
export function currentEmployerStartDate(props) {
    //TODO: change to MMYYYY
    return {
        label: "Employment Start Date",
        text: "When did " + props.you.you + " start employment there",
        name: "currentEmployerStartDate",
        answer: {
            type: "mmyyyy",
            validation: {
                max: {value: new Date(), message: "Date cannot be in the future"}
            }
        },
        hides: {
            employmentType: (v) => {
                return v !== "EMPLOYED"
            },
        },
        model: "employment"
    }
}
export function currentEmployerName(props) {
    return {
        label: "Employer",
        text: "With whom " + props.you.areYou + " currently employed?",
        name: "currentEmployerName",
        answer: {
            type: "text"
        },
        hides: {
            employmentType: (v) => {
                return v !== "EMPLOYED"
            }
        },
        model: "employment"
    }
}
export function currentEmployerAddress(props) {
    return {
        label: "Employer Address",
        text: "What is " + props.you.your + " employer's address?",
        name: "currentEmployerAddress",
        answer: {
            type: "address"
        },
        hides: {
            employmentType: (v) => {
                return v !== "EMPLOYED"
            }
        },
        model: "employment"
    }
}
export function currentEmployerContact(props) {
    return {
        label: "Contact Name",
        text: "Who can we contact at " + props.you.your + " employer?",
        name: "currentEmployerContact",
        answer: {
            type: "text"
        },
        hides: {
            employmentType: (v) => {
                return v !== "EMPLOYED"
            }
        },
        model: "employment"
    }
}
export function currentEmployerPhone(props) {
    return {
        text: "What is " + props.you.your + " employer's contact number?",
        name: "currentEmployerPhone",
        label: "Phone Number",
        answer: {
            type: "phone"
        },
        hides: {
            employmentType: (v) => {
                return v !== "EMPLOYED"
            }
        },
        model: "employment"
    }
}
export function previousEmployerName(props) {
    return {
        label: "Previous Employer",
        text: "With whom " + props.you.wereYou + " previously employed?",
        name: "previousEmployerName",
        answer: {
            type: "text"
        },
        hides: {
            employmentType: (v) => {
                return v !== "EMPLOYED"
            },
            currentEmployerYearsThere: (v) => {
                return parseInt(v) > 1
            }
        },
        model: "employment"
    }
}
export function previousEmployerAddress(props) {
    return {
        label: "Previous Employer Address",
        text: "What was " + props.you.your + " previous employer's address?",
        name: "previousEmployerAddress",
        answer: {
            type: "address"
        },
        hides: {
            employmentType: (v) => {
                return v !== "EMPLOYED"
            },
            currentEmployerYearsThere: (v) => {
                return parseInt(v) > 1
            }
        },
        model: "employment"
    }
}
export function previousEmployerYearsThere(props) {
    return {
        label: "Years with Prev Employer",
        text: "How many years " + props.you.haveYou + " been in this employment",
        name: "previousEmployerYearsThere",
        answer: {
            type: "int",
            validation: {
                min: {value: 1, message: "This must be a value greater than 1"},
                max: {value: 50, message: "50 is the maximum here"}
            }
        },
        hides: {
            employmentType: (v) => {
                return v !== "EMPLOYED"
            },
            currentEmployerYearsThere: (v) => {
                return parseInt(v) > 1
            }
        },
        model: "employment"
    }
}
export function limitedCompany(props) {
    return {
        text: "Is " + props.you.your + " business a limited company?",
        label: "Limited Company",
        name: "limitedCompany",
        answer: {
            type: "choice",
            choices: [
                {value: true, text: "Yes"},
                {value: false, text: "No"}
            ]
        },
        hides:{
            employmentType: (v) => {
                return v !== "SELFEMPLOYED"
            }
        },
        model: "employment"
    }
}
export function isDirector(props) {
    return {
        text: capitaliseFirst(props.you.areYou) + " a director or shareholder in the company?",
        label: "Director/Shareholder",
        name: "isDirector",
        answer: {
            type: "choice",
            choices: [
                {value: true, text: "Yes"},
                {value: false, text: "No"}
            ]
        },
        hides:{
            employmentType: (v) => {
                return v !== "SELFEMPLOYED"
            },
            limitedCompany: (v) =>{
                return !v
            }
        },
        model: "employment"
    }
}
export function percentageOfShares(props) {
    return {
        label: "Percentage Of Shares",
        text: "What percentage of shares "+ props.you.doYou +" hold in the company?",
        name: "percentageOfShares",
        answer: {
            type: "float"
        },
        hides: {
            employmentType: (v) => {
                return v !== "SELFEMPLOYED"
            },
            limitedCompany: (v) =>{
                return !v
            },
            isDirector: (v) =>{
                return !v
            }
        },
        model: "employment"
    }
}
export function nameOfBusiness(props) {
    return {
        label: "Business Name",
        text: "What is the business's trading name?",
        name: "nameOfBusiness",
        answer: {
            type: "text"
        },
        hides: {
            employmentType: (v) => {
                return v !== "SELFEMPLOYED"
            },
        },
        model: "employment"
    }
}
export function natureOfBusiness(props) {
    return {
        label: "Nature of Business",
        text: "What is the nature of " + props.you.your + " business?",
        name: "natureOfBusiness",
        answer: {
            type: "text"
        },
        hides: {
            employmentType: (v) => {
                return v !== "SELFEMPLOYED"
            },
        },
        model: "employment"
    }
};
export function businessAddress(props) {
    return {
        label: "Business Address",
        text: "What is the business's address?",
        name: "businessAddress",
        answer: {
            type: "address"
        },
        hides: {
            employmentType: (v) => {
                return v !== "SELFEMPLOYED"
            },
        },
        model: "employment"
    }
}
export function businessEstablished(props) {
    return {
        label: "Business Established",
        text: "When was the business established?",
        name: "businessEstablished",
        answer: {
            type: "mmyyyy"
        },
        hides: {
            employmentType: (v) => {
                return v !== "SELFEMPLOYED"
            },
        },
        model: "employment"
    }
}
export function accountantName(props) {
    return {
        label: "Accountant",
        text: "Who is " + props.you.your + " accountant?",
        name: "accountantName",
        answer: {
            type: "text"
        },
        hides: {
            employmentType: (v) => {
                return v !== "SELFEMPLOYED"
            },
        },
        model: "employment"
    }
}
export function accountantAddress(props) {
    return {
        label: "Accountant Address",
        text: "What is " + props.you.your + " accountant's address?",
        name: "accountantAddress",
        answer: {
            type: "address"
        },
        hides: {
            employmentType: (v) => {
                return v !== "SELFEMPLOYED"
            },
        },
        model: "employment"
    }
}
export function accountantPhone(props) {
    return {
        label: "Accountant's Phone",
        text: "What is their phone number?",
        name: "accountantPhone",
        answer: {
            type: "phone"
        },
        hides: {
            employmentType: (v) => {
                return v !== "SELFEMPLOYED"
            },
        },
        model: "employment"
    }
}

